import React, {useEffect} from "react";
import "../CoursePage.sass";

export default function Learning() {
    useEffect(() => {
        document.title = 'КьюАй - Учись учиться';
    }, [])

    return <>
        <div>
            Курс Учись учиться в центре детского развития КьюАй - это курс, который помогает ребятам повысить
            успеваемость в школе. Курс способствует развитию у ребенка желания самостоятельно выполнять уроки, а
            также улучшает концентрацию и запоминание данных, повышает интерес к учебе и помогает улучшить
            успеваемость в целом. Наш курс ориентирован на школьные предметы и поможет ребенку быстрее читать
            тексты из школьной программы, быстрее осваивать получаемую в школе информацию и успешно совмещать
            учебу с другими занятиями.

        </div>
        <div className="course-footer-second">
            <div className="course-footer-second-ul">
                <div className="course-footer-second-ul-title">
                    Что получит ребёнок?
                </div>
                <ul>
                    <li>Увеличение памяти как минимум в 3 раза;</li>
                    <li>Развитие способности к изучению новых иностранных языков;</li>
                    <li>Освоение навыка управления собственной памятью;</li>
                    <li>Развитие способности запоминать и пересказывать большие объемы информации;</li>
                    <li>Запоминание стихов и текстов с применением фантазии и без особых усилий;</li>
                    <li>Закрепление в памяти важных исторических дат и событий;</li>
                    <li>Увеличение скорости мышления;</li>
                    <li>Сокращение времени для выполнения домашнего задания.</li>
                </ul>
            </div>
            <div className="course-footer-second-img">
                <div className="course-footer-second-yy"></div>
            </div>
        </div>
        <div>
            По прохождению курса Учись учиться, вы сможете заметить, что память вашего ребенка стала больше, а
            также развилась способность к изучению новых иностранных языков. Также ваш ребенок разовьет
            способность запоминать и пересказывать большие объемы информации, запоминать стихи и тексты с
            помощью без специальных усилий, держать в памяти важные исторические даты и события. Кроме того,
            ребенок сможет увеличить скорость своего мышления и сократить время на выполнение домашней работы.

        </div>
        <div>
            Родители, дайте своим детям возможность учиться эффективно и с удовольствием! Центр детского
            развития КьюАй предлагает курс Учись учиться, который научит ваших детей заниматься учебой правильно
            и эффективно, чтобы достигать поставленные цели в школе и в жизни. Не пропустите эту возможность для
            развития ваших детей!

        </div>
    </>
}